import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../app/service/proveedores/proveedores.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cambiar-estatus-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './cambiar-estatus-dialog.component.html',
  styleUrl: './cambiar-estatus-dialog.component.scss'
})
export class CambiarEstatusDialogComponent {

  proveedor
  estatus = []
  estatusSelected = ''
  estatusForm: FormGroup
  estatusId

  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data: any,
      private fb: FormBuilder,
      private provedorService: ProveedoresService,
      public dialogRef: MatDialogRef<CambiarEstatusDialogComponent>) {
        this.estatusForm = this.fb.group({
          estatus: ['', [Validators.required]],
          observacion: ['', [Validators.required]],
        })
        this.proveedor = data.data
        this.estatusId = data.estatus
        this.estatusSelected = data.estatus + ''
        this.getEstatus()
  }

  ngOnInit() { }

  getEstatus(){

    this.provedorService.getEstatusProveedores(this.estatusId).subscribe(
      data => {
        this.estatus = data
      }
    )
  }

  closeDialog() {
    this.dialogRef.close({event: 2});
  }

  save(){
    this.dialogRef.close({event: 1});
  }

  guardarCambios(){
    this.dialogRef.close({event: 1, estatus: this.estatusForm.value.estatus, observacion: this.estatusForm.value.observacion})
  }

}